<div class="dashboard">
  <div class="container">
    <div class="dashboard-header">
      <h1>My Dashboard</h1>
      <p class="welcome-msg">Welcome back, <strong>{{currentUser?.username}}</strong>!</p>
    </div>

    <div class="dashboard-content">
      <!-- Main Content Area -->
      <div class="main-content">
        <!-- Services Bookings Section -->
        <div class="dashboard-section">
          <div class="section-header">
            <h2>My Service Bookings</h2>
            <span class="section-count" *ngIf="bookings.length > 0" title="Total active bookings">{{bookings.length}}</span>
          </div>
          
          <div class="bookings-list" *ngIf="bookings.length > 0; else noBookings">
            <div class="booking-card" *ngFor="let booking of bookings">
              <div class="booking-header">
                <div class="booking-title">
                  <h3>{{booking.serviceName}}</h3>
                  <span class="status" [class]="'status-' + booking.status" [title]="booking.status">
                    {{booking.status | titlecase}}
                  </span>
                </div>
              </div>
              <div class="booking-details">
                <div class="detail-row">
                  <span class="detail-label">Provider:</span>
                  <span class="detail-value">{{booking.providerName}}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">Scheduled:</span>
                  <span class="detail-value">{{booking.scheduledDate | date:'MMM dd, yyyy'}} at {{booking.scheduledTime}}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">Location:</span>
                  <span class="detail-value">{{booking.address}}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">Price:</span>
                  <span class="detail-value price">${{booking.price | number:'1.2-2'}}</span>
                </div>
                <div class="detail-row" *ngIf="booking.isRecurring">
                  <span class="detail-label">Recurring:</span>
                  <span class="detail-value badge">{{booking.recurringFrequency}}</span>
                </div>
              </div>
              <div class="booking-actions">
                <button class="btn btn-secondary"
                        *ngIf="booking.status === 'pending'"
                        (click)="cancelBooking(booking.id)"
                        title="Cancel this booking">
                  <mat-icon>close</mat-icon> Cancel
                </button>
                <button class="btn btn-primary"
                        *ngIf="booking.status === 'completed'"
                        (click)="openReviewModal(booking.id)"
                        title="Leave a review for this service">
                  <mat-icon>star</mat-icon> Leave Review
                </button>
              </div>
            </div>
          </div>

          <ng-template #noBookings>
            <div class="empty-state">
              <mat-icon class="empty-icon">event_available</mat-icon>
              <p class="empty-title">No Service Bookings Yet</p>
              <p class="empty-description">Start by browsing available services</p>
              <button class="btn btn-primary btn-large" routerLink="/browse-services" title="Explore available services">
                Browse Services
              </button>
            </div>
          </ng-template>
        </div>

        <!-- Projects Section -->
        <div class="dashboard-section" *ngIf="projects.length > 0">
          <div class="section-header">
            <h2>Active Projects</h2>
            <span class="section-count" title="Total active projects">{{projects.length}}</span>
          </div>
          
          <div class="projects-list">
            <div class="project-card" *ngFor="let project of projects" (click)="viewProjectDetails(project.id.toString())" style="cursor: pointer;">
              <div class="project-header">
                <div class="project-title">
                  <h3>{{project.title}}</h3>
                  <span class="status" [class]="'status-' + project.status" [title]="project.status">
                    {{project.status | titlecase}}
                  </span>
                </div>
              </div>
              <div class="project-details">
                <div class="detail-row">
                  <span class="detail-label">Budget:</span>
                  <span class="detail-value price">${{project.totalProjectPrice | number:'1.2-2'}}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">Progress:</span>
                  <div class="progress-bar">
                    <div class="progress-fill" [style.width.%]="(project.currentProjectPrice / project.totalProjectPrice) * 100"></div>
                  </div>
                </div>
                <div class="detail-row">
                  <span class="detail-label">Spent:</span>
                  <span class="detail-value">${{project.currentProjectPrice | number:'1.2-2'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sidebar -->
      <aside class="sidebar">
        <div class="dashboard-section quick-actions-section">
          <h2>Quick Actions</h2>
          <div class="quick-actions">
            <button class="action-btn" *ngIf="currentUser?.role === 'customer'" routerLink="/browse-services" title="Browse and book new services">
              <mat-icon class="icon">search</mat-icon>
              <span>Browse Services</span>
            </button>
            <button class="action-btn" routerLink="/payments" title="Manage your payment methods">
              <mat-icon class="icon">payment</mat-icon>
              <span>Payment Methods</span>
            </button>
            <button class="action-btn" routerLink="/service-history" title="View your service history">
              <mat-icon class="icon">history</mat-icon>
              <span>Service History</span>
            </button>
            <button class="action-btn" routerLink="/edit-account" title="Manage your account settings">
              <mat-icon class="icon">manage_accounts</mat-icon>
              <span>Account Settings</span>
            </button>
          </div>
        </div>

        <!-- Statistics Card -->
        <div class="dashboard-section stats-section">
          <h3>Your Stats</h3>
          <div class="stat-item">
            <span class="stat-label">Total Bookings:</span>
            <span class="stat-value">{{bookings.length}}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">Active Projects:</span>
            <span class="stat-value">{{projects.length}}</span>
          </div>
        </div>
      </aside>
    </div>
  </div>
</div>

<!-- Review Modal -->
<div class="modal" [class.active]="showReviewModal" *ngIf="showReviewModal">
  <div class="modal-content">
    <div class="modal-header">
      <h2>Leave a Review</h2>
      <button mat-icon-button (click)="closeReviewModal()" title="Close modal" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="review-form">
        <div class="form-group">
          <label for="rating">Rating:</label>
          <div class="rating-selector">
            <button *ngFor="let i of [1,2,3,4,5]"
                    class="star-btn"
                    [class.selected]="reviewRating === i"
                    (click)="reviewRating = i"
                    [title]="'Rate ' + i + ' stars'">
              <mat-icon>star</mat-icon>
            </button>
          </div>
        </div>
        <div class="form-group">
          <label for="comment">Your Review:</label>
          <textarea id="comment" 
                    [(ngModel)]="reviewComment" 
                    placeholder="Share your experience..."
                    rows="4"></textarea>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button mat-stroked-button (click)="closeReviewModal()">Cancel</button>
      <button mat-raised-button color="primary" (click)="submitReview()" [disabled]="reviewRating === 0">Submit Review</button>
    </div>
  </div>
</div>
